export default __webpack_public_path__ + "static/Permanent-461312159b19aeeaa260eba0abf5b646.png";